import _ from 'underscore';

import RangeExtractor from './RangeExtractorHelpers';

export const INITIAL_STATE = {
    isLoading: false,
    count: 0,
    items: [],
    page: 1,
    pageSize: 10,
};

/**
 * Create a dynamic reducer from parameters
 * @param {object} params
 * @param {string} params.ressourceName Ressource name (singular) ie. 'EVENT'
 * @param {string} params.ressourceNamePlural Ressource name (plural) ie. 'EVENTS'
 * @param {object} params.initialState Initial state
 */
export default function createRessourceReducer(params) {
    const initialState = params.initialState || INITIAL_STATE;
    return (state = initialState, action) => {
        switch (action.type) {
            case `REQUEST_GET_${params.ressourceNamePlural}`:
            case `REQUEST_GET_${params.ressourceName}`:
            case `REQUEST_PUT_${params.ressourceName}`:
            case `REQUEST_POST_${params.ressourceName}`:
            case `REQUEST_POST_${params.ressourceNamePlural}_BULK`:
            case `REQUEST_DELETE_${params.ressourceName}`:
            case `REQUEST_CLONE_${params.ressourceName}`:
                return {
                    ...state,
                    isLoading: true,
                };
            case `REQUEST_GET_${params.ressourceNamePlural}_ERROR`:
            case `REQUEST_GET_${params.ressourceName}_ERROR`:
            case `REQUEST_PUT_${params.ressourceName}_ERROR`:
            case `REQUEST_POST_${params.ressourceName}_ERROR`:
            case `REQUEST_POST_${params.ressourceNamePlural}_BULK_ERROR`:
            case `REQUEST_DELETE_${params.ressourceName}_ERROR`:
            case `REQUEST_CLONE_${params.ressourceName}_ERROR`:
                return {
                    ...state,
                    isLoading: false,
                };
            case `REQUEST_GET_${params.ressourceNamePlural}_SUCCESS`:
            case `REQUEST_POST_${params.ressourceNamePlural}_BULK_SUCCESS`:
                let paginationData = null;
                // If no
                if (action.payload.headers['content-range']) {
                    paginationData = RangeExtractor(action.payload.headers['content-range']);
                } else {
                    paginationData = {
                        count: state.count + action.payload.data.results.length,
                    };
                }
                return {
                    ...state,
                    isLoading: false,
                    items: _.uniq(
                        state.items.concat(action.payload.data.results),
                        false,
                        'id',
                    ),
                    count: _.max([paginationData.count, state.count]),
                };
            case `REQUEST_GET_${params.ressourceName}_SUCCESS`:
            case `REQUEST_PUT_${params.ressourceName}_SUCCESS`:
                // Item locally found
                if (_.find(state.items, { id: action.payload.data.results.id })) {
                    return {
                        ...state,
                        isLoading: false,
                        items: _.map(state.items, (item) => {
                            if (item.id === action.payload.data.results.id) {
                                return { ...action.payload.data.results };
                            }
                            return item;
                        }),
                    };
                }
                return {
                    ...state,
                    isLoading: false,
                    count: state.count + 1,
                    items: state.items.concat([{ ...action.payload.data.results }]),
                };
            case `REQUEST_POST_${params.ressourceName}_SUCCESS`:
            case `REQUEST_CLONE_${params.ressourceName}_SUCCESS`:
                return {
                    ...state,
                    isLoading: false,
                    items: state.items.concat([{ ...action.payload.data.results }]),
                    count: state.count + 1,
                };
            case `REQUEST_DELETE_${params.ressourceName}_SUCCESS`:
                // Item locally found
                if (_.find(state.items, { id: action.payload.data.results.id })) {
                    return {
                        ...state,
                        isLoading: false,
                        items: _.reject(state.items, (item) => (
                            item.id === action.payload.data.results.id
                        )),
                        count: state.count - 1,
                    };
                }
                return {
                    ...state,
                    isLoading: false,
                };
            case `SET_${params.ressourceNamePlural}_PAGE`:
                return {
                    ...state,
                    page: action.payload.page,
                };
            case `SET_${params.ressourceNamePlural}_PAGE_SIZE`:
                return {
                    ...state,
                    pageSize: action.payload.pageSize,
                };
            case `FLUSH_${params.ressourceNamePlural}`:
                return {
                    ...state,
                    count: 0,
                    items: [],
                };
            default:
                return state;
        }
    };
}
